import { ApiService } from '../shared/services/api-service/api.service';
import { IBraintreeConfigurations } from './interfaces/braintree-configurations.interfaces';
/**
 * @ignore
 */

class BraintreeConfigurationsClass {
    async getBraintreeConfigurations(hotelCode: number) {
        try {
            const braintreeConfigurationResponse: Response = await ApiService.getBraintreeConfigurations(hotelCode);
            const basicAvailObject: IBraintreeConfigurations = await braintreeConfigurationResponse.json();
            return basicAvailObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const BraintreeConfigurationService = new BraintreeConfigurationsClass();
